import { POSITIONS } from "constant/variables";

export const getIsAdmin = () => {
    return localStorage.getItem("is_admin") == "true";
}

export const getOutletRegion = () => {
    const outletName = localStorage.getItem("Outlet");
    const regionName = localStorage.getItem("Region");
    const OwnerPosition = JSON.parse(localStorage.getItem("Position"));
  
    let name = "";
  
    if(POSITIONS.AGENT === OwnerPosition || POSITIONS.OUTLET_MANAGER === OwnerPosition) {
      name = outletName;
    } else if(POSITIONS.MANAGER === OwnerPosition) {
      name = regionName;
    }
    return name;
  }
  
  export const getFileExtension = (filename="") => {
    const extension = filename.substring(filename.lastIndexOf('.') + 1, filename.length);
    return extension;
}